module.exports = __webpack_public_path__ + "static/MABinc-logo-63622ab4f03a57cb0de4a532d0c0c049.png";